/**
 * External Imports
 */
import { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';

/**
 * Internal Imports
 */
import { RootState } from '../../../redux/store';
import { usePostDischargePatientsMutation } from '../../../redux/apis/Admin.api';

/**
 * Style Imports
 */
import { StyledDischargeBtn } from './DischargeBtn.styles';

interface DischargeProps {
  dischargeParams: { accountNumbers: string[]; facilityId: string };
}

const DischargeBtn: FC<DischargeProps> = ({ dischargeParams }) => {
  const [enableButtonFlag, setEnableButtonFlag] = useState<boolean>(true);

  const [
    postDischargePatients
    // {
    //   isError: isPostDischargePatientsError,
    //   isLoading: isPostDischargePatientsLoading,
    //   isSuccess: isPostDischargePatientsSuccess
    // }
  ] = usePostDischargePatientsMutation();

  const dischargePatient = async () => {
    if (dischargeParams?.accountNumbers.length > 0)
      await postDischargePatients(dischargeParams);
    else {
      // TODO: Should we toast here
      console.log(`Please select a patient to discharge`);
    }
  };

  useEffect(() => {
    if (dischargeParams) {
      if (
        dischargeParams.accountNumbers &&
        dischargeParams.accountNumbers.length > 0
      ) {
        setEnableButtonFlag(false);
      } else {
        setEnableButtonFlag(true);
      }
    }
  }, [dischargeParams]);

  return (
    <StyledDischargeBtn
      data-testid="discharge-button"
      className="me-3"
      color="blue"
      disabled={enableButtonFlag}
      icon="add"
      kind="primary"
      size="small"
      onClick={dischargePatient}
    >
      {/* {view?.includes('issues') && 'Add Issue'} */}
      Discharge Scheduled Patients
    </StyledDischargeBtn>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    dischargeParams: state.UserReducer.dischargeParams,
    selectedFacility: state.AdminReducer.selectedFacility
  };
};
export default connect(mapReduxStateToProps)(DischargeBtn);
